<div tdWbContainerSize
     (sizeChange)="containerSizeChange($event)">
  @if (isLoading()) {
    <div [@slideInOutAnimation]>
      <td-wb-loading-indicator-panel>
        <td-wb-loading-indicator position="center"
                                 [displayDelay]="0">
        </td-wb-loading-indicator>
      </td-wb-loading-indicator-panel>
    </div>
  } @else {
    <!-- Detail quote content -->
    <div role="region"
         aria-labelledby="td-wb-aria-quote-details-title"
         [ngClass]="{'td-wb-quote__symbol-quote-details' : displaySymbolDetail}"
         class="td-wb-quote"
         [@slideInOutAnimation]>
      <h2 class="td-wb-vh"
          id="td-wb-aria-quote-details-title"
          translate="tdWb.markets.quote.QUOTE_DETAILS"></h2>
      @if (displaySymbolDetail) {
        <td-wb-detailed-symbol-header
          [viewSizeCompact]="isSmallScreen()"
          [symbol]="getSymbol()"
          [quote]="quote"
          [hideAddToWatchlistButton]="hideAddToWatchlistButton"
          [hideInterlistExchangeForOTC]="hideInterlistExchangeForOTC"
          [displaySymbolDetail]="displaySymbolDetail"
          (onShowExchange)="showInterlistedExchangeQuote()">
        </td-wb-detailed-symbol-header>
      }
      @if (hideQuoteDetail()) {
        <div>
          <td-wb-notification class="td-wb-quote__no-details-warning-message"
                              notificationType="error">
            <span translate="tdWb.markets.quote.quotecharts.TRADING_HALTED"></span>
          </td-wb-notification>
        </div>
      } @else {
        <ng-template [ngTemplateOutlet]="castToNgIfContextTemplateRef(currentTemplateRef)"></ng-template>
      }
    </div>
  }
</div>


<ng-template #fixedIncome>
  <div class="td-wb-quote__no-details-warning-message">
    <span translate="tdWb.markets.quote.FIXED_INCOME_MESSAGE_1"></span>
    <span><a translate="tdWb.markets.quote.FIXED_INCOME_MESSAGE_URL"
             class="td-wb-quote__fixed-income-link"
             tdWbHref="link_fixed_income"
             target='_parent'></a></span>
    <span translate="tdWb.markets.quote.FIXED_INCOME_MESSAGE_2"></span>
  </div>
</ng-template>

<ng-template #invalidSymbol>
  <div *tdWbIfNoFeature="'simplfiedErrorsExpandedQuote'"
       class="td-wb-quote__no-details-warning-message"
       translate="tdWb.markets.quote.NO_INFO"></div>
  <td-wb-empty *tdWbIfFeature="'simplfiedErrorsExpandedQuote'">
    <td-wb-empty-header translate="tdWb.markets.quote.SECURITY_DETAILS_UNAVAILABLE"></td-wb-empty-header>
  </td-wb-empty>
</ng-template>

<!-- Template for ErrorMessage, UnknownSymbol and NoPermission-->
<ng-template #message>
  <td-wb-detailed-quote-message [template]="template"
                                [symbol]="getSymbol()"
                                [tradeInfo]="tradeInfo"
                                [hideHeader]="displaySymbolDetail">
  </td-wb-detailed-quote-message>
</ng-template>

<!-- Template for issueType -->
<ng-template #issueType>
  <ng-container *ngTemplateOutlet="isSmallScreen() ? compactView : wideView"></ng-container>
</ng-template>

<ng-template #wideView>
  @if (!displaySymbolDetail) {
    <td-wb-detailed-symbol-header
      [symbol]="getSymbol()"
      [quote]="quote"
      [hideAddToWatchlistButton]="hideAddToWatchlistButton"
      [hideInterlistExchangeForOTC]="hideInterlistExchangeForOTC"
      [displaySymbolDetail]="false"
      (onShowExchange)="showInterlistedExchangeQuote()">
    </td-wb-detailed-symbol-header>
  }

  <div class="td-wb-quote__content"
       [ngClass]="{'td-wb-quote__symbol-quote-details-content' : displaySymbolDetail}">
    <div class="td-wb-quote__left">
      <td-wb-quote-chart
        [quote]="quote"
        [noChartData]="noChartData"
        [closePrice]="getClosePrice()"
        [displayTimeSeries]="displayTimeSeries"
        [options]="chartConfig"
        [closeSeries]="seriesData"
        [chartSize]="getChartSize()"
        (onTabChange)="onTabChange($event)"
        (onTimeRangeChange)="onTimeRangeChange()"
        (onFrequencyChange)="onFrequencyChange()"
        (onTypeChange)="onTypeChange()">
      </td-wb-quote-chart>
      @if (hasModPermission()) {
        <div class="td-wb-quote__chart-footer">
          <td-wb-quote-link [quote]="quote"></td-wb-quote-link>
        </div>
      }
    </div>

    <div class="td-wb-quote__right">
      <h2 id="td-wb-aria-security-info-title"
          class="td-wb-vh"
          translate="tdWb.markets.quote.SECURITY_INFORMATION"></h2>
      <td-wb-tabs class="td-wb-quote__tabs"
                  type="secondary"
                  [selectedTabId]="selectedTab"
                  (selectedTabIdChange)="switchTab($event)">
        <td-wb-tab tabId="SUMMARY">
          <span translate="tdWb.markets.quote.QUOTE"></span>
        </td-wb-tab>
        <td-wb-tab tabId="MORE_DETAILS">
          <span [translate]="'tdWb.markets.quote.' + (isMutualFund() ? 'MORE_DETAILS' : 'FUNDAMENTALS')"></span>
        </td-wb-tab>
      </td-wb-tabs>
      @if (selectedTab === 'SUMMARY') {
        <td-wb-detailed-quote-summary
          [quote]="quote">
        </td-wb-detailed-quote-summary>
      }
      @if (selectedTab === 'MORE_DETAILS') {
        <td-wb-detailed-quote-more-details
          [quote]="quote">
        </td-wb-detailed-quote-more-details>
      }
      <ng-container *ngTemplateOutlet="commonQuoteSummaryContent"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #compactView>
  @if (!displaySymbolDetail) {
    <td-wb-detailed-symbol-header
      [viewSizeCompact]="true"
      [symbol]="getSymbol()"
      [quote]="quote"
      [hideAddToWatchlistButton]="hideAddToWatchlistButton"
      [hideInterlistExchangeForOTC]="hideInterlistExchangeForOTC"
      [displaySymbolDetail]="false"
      (onShowExchange)="showInterlistedExchangeQuote()">
    </td-wb-detailed-symbol-header>
  }

  <td-wb-tabs class="td-wb-quote__tabs"
              type="secondary"
              [selectedTabId]="selectedTab"
              (selectedTabIdChange)="switchTab($event)">
    <td-wb-tab tabId="CHART">
      <span translate="tdWb.markets.quote.CHARTS"></span>
    </td-wb-tab>
    <td-wb-tab tabId="SUMMARY">
      <span translate="tdWb.markets.quote.QUOTE"></span>
    </td-wb-tab>
    <td-wb-tab tabId="MORE_DETAILS">
      <span [translate]="'tdWb.markets.quote.' + (isMutualFund() ? 'MORE_DETAILS' : 'FUNDAMENTALS')"></span>
    </td-wb-tab>
  </td-wb-tabs>

  @if (selectedTab === 'CHART') {
    <div
      class="td-wb-quote__chart">
      <!-- chart -->
      <td-wb-quote-chart
        [quote]="quote"
        [noChartData]="noChartData"
        [closePrice]="getClosePrice()"
        [displayTimeSeries]="displayTimeSeries"
        [options]="chartConfig"
        [closeSeries]="seriesData"
        [chartSize]="getChartSize()"
        (onTabChange)="onTabChange($event)"
        (onTimeRangeChange)="onTimeRangeChange()"
        (onFrequencyChange)="onFrequencyChange()"
        (onTypeChange)="onTypeChange()">
      </td-wb-quote-chart>
      <!-- Footer links-->
      @if (hasModPermission()) {
        <div class="td-wb-quote__chart-footer">
          <td-wb-quote-link [quote]="quote"></td-wb-quote-link>
        </div>
      }
    </div>
  }
  @if (selectedTab === DetailedQuoteTab.SUMMARY) {
    <td-wb-detailed-quote-summary [quote]="quote"></td-wb-detailed-quote-summary>
    <ng-container *ngTemplateOutlet="commonQuoteSummaryContent"></ng-container>
  }
  @if (selectedTab === DetailedQuoteTab.MORE_DETAILS) {
    <td-wb-detailed-quote-more-details [quote]="quote"></td-wb-detailed-quote-more-details>
    <ng-container *ngTemplateOutlet="commonQuoteSummaryContent"></ng-container>
  }
</ng-template>

<ng-template #commonQuoteSummaryContent>
  <!-- Analyst Start Ratings -->
  @if (showStarRating()) {
    <div class="td-wb-quote__ratings">
      <div class="td-wb-quote__ratings-label"
           translate="tdWb.markets.quote.MORNINGSTAR_RATING"></div>
      <div class="td-wb-quote__ratings-label">
        <td-wb-star-rating [stars]="quote.morningStarRating"></td-wb-star-rating>
      </div>
    </div>
  }

  <!-- Analyst Ratings (STOCK only)-->
  @if (showAnalystRating()) {
    <div class="td-wb-quote__ratings"> <!-- Analyst Ratings provided -->
      <div class="td-wb-quote__ratings-label">
        <td-wb-analyst-ratings-tooltip position="end-bottom"></td-wb-analyst-ratings-tooltip>
      </div>
      <div class="td-wb-quote__ratings-label">
        <td-wb-analyst-rating class="td-wb-quote__ratings-component"
                              [consensus]="quote.consensus"
                              [symbol]="quote.symbol"
                              [market]="quote.country">
        </td-wb-analyst-rating>
      </div>
    </div>
  }
  <!-- Warning Message-->
  @if (showWarningMessage() && quote.warningMessage) {
    <div class="td-wb-quote__warning-message">
      <td-wb-icon class="td-wb-quote__warning-icon"
                  iconId="warning--small"
                  [inline]="true">
      </td-wb-icon>
      <span [innerText]="quote.warningMessage"></span>
    </div>
  }
  <!-- Buy n Sell (except INDEX)-->
  @if (showBuySell()) {
    <div class="td-wb-quote__buy-sell-buttons">
      <td-wb-buy-sell-buttons type="primary"
                              size="regular"
                              [tradeInfo]="tradeInfo">
      </td-wb-buy-sell-buttons>
    </div>
  }
  <!-- Timestamp-->
  @if (quote.timestamp) {
    <div class="td-wb-quote__timestamp"
         [translate]="isMutualFund() ? 'tdWb.markets.quote.AS_OF_MARKET_CLOSE' : 'tdWb.markets.quote.AS_OF'"
         [translateParams]="{ timestamp: quote.timestamp | tdWbDate: { format: 'DATE_TIME' } }">
    </div>
  }
</ng-template>
